import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import EmailIcon from 'dibs-vg/dist/react/email';
import ChatIcon from 'dibs-vg/dist/react/message';

import classNames from 'classnames';

import styles from './Contact.scss';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.handleChatClick = this.handleChatClick.bind(this);
    }

    handleChatClick(e) {
        e.preventDefault();
        this.props.showChatUtils();
    }

    render() {
        return (
            <div className="contact rowFlex">
                <div className="rowWrapper">
                    <BarHeader
                        title={
                            <div className={styles.header}>
                                <FormattedMessage
                                    id="abt.sourcing.contact.header"
                                    defaultMessage="Contact Our Trade Sourcing Specialists"
                                />
                            </div>
                        }
                    />
                    <div className={classNames(styles.iconWrapper, 'rowFlex')}>
                        <div className={styles.iconItem}>
                            <EmailIcon className={styles.emailIcon} />
                            <div className={styles.iconContentWrapper}>
                                <div className={styles.iconHeader}>
                                    <FormattedMessage
                                        id="abt.sourcing.contact.emailHeader"
                                        defaultMessage="Email"
                                    />
                                </div>
                                <div className={styles.iconContent}>
                                    <FormattedHTMLMessage
                                        id="abt.sourcing.contact.emailSubheader"
                                        defaultMessage="Email us at <a href='mailto:sourcing@1stdibs.com'>sourcing@1stdibs.com</a>"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.iconItem}>
                            <ChatIcon className={styles.chatIcon} />
                            <div className={styles.iconContentWrapper}>
                                <div className={styles.iconHeader}>
                                    <FormattedMessage
                                        id="abt.sourcing.contact.chatHeader"
                                        defaultMessage="Live Chat"
                                    />
                                </div>
                                <div className={styles.iconContent}>
                                    <FormattedMessage
                                        id="abt.sourcing.contact.chatSubheader"
                                        defaultMessage="We're available Monday through Friday 10am-6pm EST."
                                    />
                                    <br />
                                    <a href="#0" data-tn="chat-link" onClick={this.handleChatClick}>
                                        <FormattedMessage
                                            id="abt.sourcing.contact.chatCTA"
                                            defaultMessage="Chat Now"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Contact.propTypes = {
    showChatUtils: PropTypes.func,
};

Contact.defaultProps = {
    showChatUtils: () => {},
};

export default Contact;
